import { ISlateSpacing } from "@faire/web-api--source/indigofair/data/ISlateSpacing";

export const getSlateSpacingPixels = (
  spacing: keyof typeof ISlateSpacing.Spacing
): number => {
  return spacingToNumberMap[spacing];
};

export const getSlateSpacingPixelsString = (
  spacing: keyof typeof ISlateSpacing.Spacing
): string => {
  return `${getSlateSpacingPixels(spacing)}px`;
};

// Spacing values come from https://www.figma.com/file/s7VxgVsNoO1smpdecnUYoN/Faire-Slate?type=design&node-id=4449-12646&mode=design&t=crJA1bdzBVGLE3uu-0
const spacingToNumberMap: Record<ISlateSpacing.Spacing, number> = {
  XXXL: 72,
  XXL: 48,
  XL: 32,
  L: 24,
  R: 16,
  S: 12,
  XS: 8,
  XXS: 4,
  XXXS: 2,
  SPACING_NONE: 0,
  SPACING_UNKNOWN: 0,
};
